import React, { useState, useEffect } from 'react';
import Pagination from './Pagination/Pagination';
import './filterOrderPagination.css';

const FilterOrderPagination = ({ 
  data, 
  itemsPerPage, 
  totalPages, 
  onPageChange, 
  totalItems, 
  onOrderChange, 
  type,
  orderBy,
  currentPage: parentCurrentPage
}) => {
  const [filteredData, setFilteredData] = useState([]);


  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  const handleOrderChange = (e) => {
    const selectedOrder = e.target.value;
    if (onOrderChange) {
      onOrderChange(selectedOrder);
    }
  };

  const handlePageChange = (page) => {
    onPageChange(page);
  };

  const orderOptions = type === 'job'
    ? [
        { value: 'date', label: 'Fecha de publicación' },
        { value: 'applications', label: 'Nro de Aplicaciones' },
      ]
    : type === 'companies'
    ? [
        { value: 'popularity', label: 'Popularidad' },
        { value: 'scale', label: 'Tamaño' },
      ]
    : [];

  return (
    <div className="filter-order-pagination__container">
      <div>
        <h4>Ordenar por:</h4>
        <select onChange={handleOrderChange} value={orderBy} className='filter-order-pagination__select'>
          {orderOptions.map((option) => (
            <option key={option.value} value={option.value} className='filter-order-pagination__option'>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <Pagination
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
        currentPage={parentCurrentPage}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default FilterOrderPagination;
